import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import duster from "../../../../assets/info/duster-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import { popularVehicle } from "../../../../vars/popularVehicles";

const DaciaDuster = () => {
  useSmallNav("Dacia Duster");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Dacia Duster"} bolder />
        <InfoHero image={duster} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Do you own and drive a Dacia Duster? Looking for suspension parts or suspension upgrades?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Then you have come to the right place."}
            />
            <p>
              The Duster is great vehicle, at a great price, but, depending on
              your use of the vehicle, maybe you are looking for a bit more from
              your Duster suspension.
            </p>
            <p>
              Here at Pedders Suspension we offer a range of suspension parts
              including upgraded shocks and springs.
            </p>
            <p>
              As well as upgraded shocks, we also raising springs, in both
              comfort and heavy duty variants. Whatever your usage, we will have
              a combination of parts to do the job.
            </p>
            <p>Please take a look at out Duster parts and kits.</p>
            <p>
              Not sure which one you require? Then please do get in touch, where
              one of our team will be able to assist you.
            </p>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Dacia Duster Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Dacia Duster Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Dacia")
              .models.find((e) => e.display === "Duster")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
      </Container>
    </section>
  );
};

export default DaciaDuster;
